import { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

import { request } from "app/network";

interface SurgerySiteModalProps {
    open: boolean;
    onClose: () => void;
    onSuccess: () => void;
    surgerySite?: any; // If provided, it's edit mode
}

const SurgerySiteModal = ({ open, onClose, onSuccess, surgerySite }: SurgerySiteModalProps) => {
    const [siteCode, setSiteCode] = useState("");
    const [siteName, setSiteName] = useState("");
    const [comment, setComment] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (surgerySite) {
            setSiteCode(surgerySite.siteCode || "");
            setSiteName(surgerySite.siteName || "");
            setComment(surgerySite.comment || "");
        } else {
            setSiteCode("");
            setSiteName("");
            setComment("");
        }
    }, [surgerySite, open]);

    const handleSubmit = async () => {
        if (!siteCode || !siteName) {
            alert("수술부위 코드와 이름을 입력해주세요.");
            return;
        }

        setLoading(true);
        try {
            if (surgerySite) {
                // Edit mode
                await request("SurgerySite.update", {
                    pathParams: { seqId: surgerySite.seqId },
                    paramz: {
                        SeqId: surgerySite.seqId,
                        SiteCode: siteCode,
                        SiteName: siteName,
                        Comment: comment,
                    }
                });
            } else {
                // Create mode
                await request("SurgerySite.create", {
                    paramz: {
                        SiteCode: siteCode,
                        SiteName: siteName,
                        Comment: comment,
                    }
                });
            }
            onSuccess();
        } catch (error: any) {
            console.error("저장 실패:", error);
            alert(error?.response?.data?.message || "저장에 실패했습니다.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>{surgerySite ? "수술부위 수정" : "수술부위 등록"}</DialogTitle>
            <DialogContent>
                <MDBox pt={2} pb={2}>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <TextField
                                label="수술부위 코드"
                                fullWidth
                                value={siteCode}
                                onChange={(e) => setSiteCode(e.target.value)}
                                required
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label="수술부위 이름"
                                fullWidth
                                value={siteName}
                                onChange={(e) => setSiteName(e.target.value)}
                                required
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label="코멘트"
                                fullWidth
                                multiline
                                rows={4}
                                value={comment}
                                onChange={(e) => setComment(e.target.value)}
                            />
                        </Grid>
                    </Grid>
                </MDBox>
            </DialogContent>
            <DialogActions>
                <MDButton onClick={onClose} variant="outlined" color="dark">
                    취소
                </MDButton>
                <MDButton
                    onClick={handleSubmit}
                    variant="gradient"
                    color="info"
                    disabled={loading}
                >
                    {loading ? "저장 중..." : "저장"}
                </MDButton>
            </DialogActions>
        </Dialog>
    );
};

export default SurgerySiteModal;
